const apiRoot = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

const adminRequest = async (path, options = {}) => {
  const identityToken = localStorage.getItem('id_token');
  if (!identityToken) {
    throw new Error('Your session has expired. Please log in again.');
  }

  const response = await fetch(`${apiRoot}/admin${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${identityToken}`,
      ...options.headers
    }
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error || 'The admin request failed.');
    error.status = response.status;
    throw error;
  }

  return payload;
};

export const checkAdminAccess = async () => {
  const payload = await adminRequest('/access');
  return payload.isAdmin === true;
};

export const getApiKeys = async () => {
  const payload = await adminRequest('/api-keys');
  return payload.keys;
};

export const updateApiKey = async (keyId, value) => {
  const payload = await adminRequest(`/api-keys/${encodeURIComponent(keyId)}`, {
    method: 'PUT',
    body: JSON.stringify({ value })
  });
  return payload.key;
};
